module.exports = __webpack_public_path__ + "static/media/development.e929ffbf.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sections/development.jpeg
// module id = 388
// module chunks = 0